import { render, staticRenderFns } from "./appLoginForm.vue?vue&type=template&id=19408626&"
import script from "./appLoginForm.vue?vue&type=script&lang=js&"
export * from "./appLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports